import { mapState, mapGetters } from 'vuex'

import registerStoreModuleMixin from '@/mixins/register-store-module'
import { getParamsByQuery } from '@/utils/urls/mapper'
import optimizeActivate from '@/mixins/optimize-activate'
import tracker from '@/utils/tracking/tracker'

import recommendationsSettings from './oz-recommendations.settings'
import trackingHelper from './tracking'

const ozUserRecommendations = () => import(/* webpackChunkName: "oz-user-recommendations" */ '@/components/oz-user-recommendations')

export default {
  name: 'discover',

  mixins: [registerStoreModuleMixin, optimizeActivate],

  computed: {
    ...mapState({
      glossary: (state) => state.context.glossary,
      unitTypeGlossary: (state) => state.context.unitTypeGlossary,
    }),

    ...mapGetters({
      currentHash: 'currentHash',
    }),

    filters () {
      return getParamsByQuery(this.currentHash, this.glossary, this.unitTypeGlossary)
    },

  },

  data () {
    return {
      recommendationsSettings,
    }
  },

  created () {
    this.$store.commit('page/setMetaContent', {
      title: 'ZAP Imóveis | Veja as recomendações de imóveis que o ZAP tem para você!',
      description: 'Descubra novos imóveis e veja as melhores ofertas de casas e apartamentos selecionados pelo ZAP especialmente para você!',
    })
  },

  beforeRouteEnter (to, from, next) {
    if (__BROWSER__) {
      next((vm) => {
        vm.initTrackers()
      })
    } else {
      next()
    }
  },

  beforeRouteUpdate (to, from, next) {
    if (__BROWSER__) {
      this.initTrackers()
    }
    next()
  },

  methods: {
    initTrackers () {
      if (!__BROWSER__) return
      tracker.trackPageView(this.$store, trackingHelper.pageView())
      tracker.trackPageRendered()
    },
  },

  components: {
    ozUserRecommendations,
  },
}
